import * as React from 'react'
import { cn } from '@/lib/utils'

/*
 * IconButton: an icon-only control inside a 44x44px navigation target. An
 * accessible name is mandatory — an icon never appears without one.
 */
function IconButton({
  label,
  className,
  children,
  ...props
}: React.ComponentProps<'button'> & { label: string }) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={cn(
        'relative inline-flex size-11 shrink-0 items-center justify-center rounded-sm text-fg-muted transition-colors',
        'hover:bg-surface-hover hover:text-fg',
        "[&_svg:not([class*='size-'])]:size-5",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  )
}

export { IconButton }
